<template>
  <div class="uk-width-2xlarge uk-margin-auto">

    <kmc-contact-like v-if="calculationResult && requestingLikeCallback" :labels="labels" :data="calculationResult"></kmc-contact-like>

    <kmc-calculator-result v-if="calculationResult && !requestingLikeCallback" :labels="labels" :data="calculationResult" v-on:recalculate="recalculate()" v-on:requestLikeCallback="requestLikeCallback"></kmc-calculator-result>

    <div ref="calculator" :class="{'uk-hidden':calculationResult}">

      <div v-html="beforeIntroSection" class="uk-margin-bottom "></div>

      <hr v-if="beforeIntroSection" style="border-top-width: 1px;" class="uk-margin-medium"/>

      <div v-html="introSectionTitle" class="uk-h3 uk-margin"></div>

      <div v-html="introSectionBody"></div>

      <hr style="border-top-width: 1px;" class="uk-margin-medium"/>

      <div v-html="formSectionTitle" class="uk-h3 uk-margin"></div>
      <div v-html="formSectionBody" class="uk-margin uk-margin-medium-bottom"></div>

      <form class="uk-form-stacked" @submit="onSubmit" novalidate autocomplete="off">

        <kmc-input-radio-buttons class="kmc-form-control uk-display-block"
                                 v-bind="fields.applicantType"
                                 :name="'applicantType'"
                                 @change="onApplicantTypeChange"/>

        <kmc-input-radio-buttons class="kmc-form-control uk-display-block"
                                 v-bind="fields.loanPurpose"
                                 :name="'loanPurpose'"/>

        <kmc-input-radio class="kmc-form-control  uk-display-block"
                         v-bind="fields.stage"
                         :name="'stage'"/>

        <kmc-input-number class="kmc-form-control uk-display-block uk-width-1-1"
                          :name="'loanTermYears'"
                          v-bind="fields.loanTermYears"/>

        <kmc-input-currency class="kmc-form-control  uk-display-block uk-width-1-1"
                            :name="'monthlyRentalIncome'"
                            v-bind="fields.monthlyRentalIncome"/>

        <kmc-input-currency class="kmc-form-control  uk-display-block uk-width-1-1"
                            :name="'propertyValuation'"
                            v-bind="fields.propertyValuation"/>

        <kmc-input-currency class="kmc-form-control  uk-display-block uk-width-1-1"
                            :name="'loanAmount'"
                            v-bind="fields.loanAmount"/>

        <kmc-input-radio-buttons class="kmc-form-control uk-display-block"
                                 v-bind="fields.btlExistingPortfolio"
                                 :name="'btlExistingPortfolio'"
                                 @change="onBtlExistingPortfolioChange"/>

        <!--suppress EqualityComparisonWithCoercionJS -->
        <div v-if="values.btlExistingPortfolio == 1">
          <kmc-input-number class="kmc-form-control uk-display-block uk-width-1-1"
                            :name="'btlPortfolioPropertiesCount'"
                            v-bind="fields.btlPortfolioPropertiesCount"/>

          <kmc-input-number class="kmc-form-control uk-display-block uk-width-1-1"
                            :name="'btlPortfolioMortgagedPropertiesCount'"
                            v-bind="fields.btlPortfolioMortgagedPropertiesCount"/>

          <kmc-input-currency class="kmc-form-control  uk-display-block uk-width-1-1"
                              :name="'btlPortfolioMonthlyCombinedRentalIncome'"
                              v-bind="fields.btlPortfolioMonthlyCombinedRentalIncome"/>

          <kmc-input-currency class="kmc-form-control  uk-display-block uk-width-1-1"
                              :name="'btlPortfolioTotalEstimatedPropertiesValue'"
                              v-bind="fields.btlPortfolioTotalEstimatedPropertiesValue"/>

          <kmc-input-currency class="kmc-form-control  uk-display-block uk-width-1-1"
                              :name="'btlPortfolioTotalOutstandingMortgagesAmount'"
                              v-bind="fields.btlPortfolioTotalOutstandingMortgagesAmount"/>
        </div>

        <kmc-input-dropdown class="kmc-form-control uk-display-block"
                            v-bind="fields.propertyRegion"
                            :name="'propertyRegion'"/>


        <kmc-input-radio-buttons class="kmc-form-control uk-display-block"
                                 :name="'propertyIsHouseInMultipleOccupation'"
                                 v-bind="fields.propertyIsHouseInMultipleOccupation"/>

        <kmc-input-radio-buttons class="kmc-form-control uk-display-block"
                                 :name="'propertyIsMultiUnitBlock'"
                                 v-bind="fields.propertyIsMultiUnitBlock"/>



        <!--suppress EqualityComparisonWithCoercionJS -->
        <div v-if="values.applicantType == 'Individual'">

          <kmc-input-radio-buttons class="kmc-form-control  uk-display-block"
                                   :name="'applicantsCount'"
                                   v-bind="fields.applicantsCount"/>

          <kmc-input-currency class="kmc-form-control  uk-display-block uk-width-1-1"
                              :name="'applicant1Income'"
                              v-bind="fields.applicant1Income"/>

          <kmc-input-currency v-if="values.applicantsCount == 2"
                              class="kmc-form-control uk-display-block uk-width-1-1"
                              :name="'applicant2Income'"
                              v-bind="fields.applicant2Income"/>

          <kmc-input-currency
              class="kmc-form-control  uk-display-block uk-width-1-1"
              :name="'applicant1CreditExpenditure'"
              v-bind="fields.applicant1CreditExpenditure"/>

          <kmc-input-currency v-if="values.applicantsCount == 2"
                              class="kmc-form-control uk-display-block uk-width-1-1"
                              :name="'applicant2CreditExpenditure'"
                              v-bind="fields.applicant2CreditExpenditure"/>

          <kmc-input-dropdown class="kmc-form-control uk-display-block"
                              v-bind="fields.ageGroup"
                              :name="'ageGroup'"/>

          <kmc-input-dropdown v-if="values.applicantsCount == 2"
                              class="kmc-form-control uk-display-block"
                              v-bind="fields.ageGroup2"
                              :name="'ageGroup2'"/>

          <kmc-input-postcode class="kmc-form-control uk-display-block uk-width-1-1"
                              :name="'postcode'"
                              v-bind="fields.postcode"/>
        </div>

        <div class="uk-alert uk-alert-danger uk-border-rounded" v-if="!isValid && submitCount" v-html="labels['formGenericErrorMessage']"/>

        <div class="uk-alert uk-alert-danger uk-border-rounded" v-if="submitErrorMessage && isValid && submitCount" v-html="submitErrorMessage"></div>

        <kmc-loading-mask v-if="loading" :message="loadingMaskMessage"></kmc-loading-mask>

        <div class="uk-margin uk-margin-medium-bottom uk-text-center">
          <button type="submit" class="uk-button uk-button-primary uk-width-1-2@m" v-html="labels['submitBtnLabel']"/>
        </div>

      </form>

      <details v-if="isDebug">
        <summary>Debug Form State</summary>
        <div>Valid: {{ isValid }}</div>
        <pre class="uk-text-small" v-text="values"></pre>
        <div>Errors:</div>
        <pre class="uk-text-small kmc-color-3" v-text="errors"></pre>
      </details>


    </div>

    <details class="uk-text-small" v-if="isDebug">
      <summary>API Debug</summary>
      <div class="uk-text-bold">Request:</div>
      <pre class="uk-text-small" v-text="apiDebugData['request']"></pre>
      <div class="uk-text-bold">Response:</div>
      <pre class="uk-text-small" v-text="apiDebugData['response']"></pre>
    </details>

  </div>

</template>

<script>

import {onBeforeMount, onMounted, ref} from 'vue'
import {useForm, useFormErrors, useFormValues, useIsFormValid} from "vee-validate";
import {KmcCalculatorResult, KmcContactLike, KmcInputAutocomplete, KmcInputCurrency, KmcInputDropdown, KmcInputNumber, KmcInputPostcode, KmcInputRadio, KmcInputRadioButtons, KmcInputText, KmcLoadingMask} from "../components";
import {useKmcForms} from "./index"
import {formatCurrency, getReCaptchaToken, reportToInsight} from "../util";
import * as Yup from "yup";
import {currency, postcode} from "../validations";

export default {
  name: "BtlMortgageCalculator",
  components: {KmcCalculatorResult, KmcLoadingMask, KmcInputDropdown, KmcInputRadio, KmcInputRadioButtons, KmcInputCurrency, KmcInputPostcode, KmcInputText, KmcInputNumber, KmcInputAutocomplete, KmcContactLike},
  props: {
    data: Object
  },
  setup(props, context) {

    const isDebug = ref(window['sfEnv']['isDebug']);

    const fields = props.data.fields || {} //from SF json definition
    const labels = props.data.labels || {} //from SF json definition
    const productTable = props.data['productTable'] || {}


    const maxLtv = props.data.labels['maxLtv']; // LTV is 85%
    const maxLtvMessage = props.data.labels['maxLtvMessage'];

    if (isDebug) {
      console.log(props.data)
    }

    const schema = ref({})
    const {handleSubmit, setErrors, errors, handleReset, isSubmitting, meta, setValues, setFieldValue, submitCount, resetForm} = useForm({validationSchema: schema})
    const {setSchema} = useKmcForms(fields, schema, {setFieldValue, setValues})

    const loading = ref(false)

    const formSubmitErrorMessage = labels['formSubmitErrorMessage']
    const loadingMaskMessage = labels['loadingMaskMessage']
    const submitErrorMessage = ref()

    const beforeIntroSection = labels['beforeIntroSection']

    const formSectionTitle = labels['formSectionTitle']
    const formSectionBody = labels['formSectionBody']
    const introSectionTitle = labels['introSectionTitle']
    const introSectionBody = labels['introSectionBody']

    const isValid = useIsFormValid()
    const values = useFormValues()
    const errs = useFormErrors()

    const calculationResult = ref()

    const requestingLikeCallback = ref(false)

    const apiDebugData = ref({})

    window.onpopstate = function (event) {
      if (event.state && event.state.data) {
        setTimeout(() => {
          calculationResult.value = event.state.data

          if (event.state.data.requestingLikeCallback) {
            requestingLikeCallback.value = true
          }
        }, 0)
      }
      calculationResult.value = null
      requestingLikeCallback.value = false
    }

    const presentResults = function (data) {
      history.pushState({data}, 'Calculation result')
      calculationResult.value = data;
    }

    const onSubmit = handleSubmit(async (values) => {
      if (loading.value) return;

      try {
        loading.value = true
        submitErrorMessage.value = ''

        const token = await getReCaptchaToken();
        const search = new URLSearchParams({token})

        const requestData = prepareData(values)

        const response = await fetch(`${location.pathname}/Calculate?${search}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestData)
        });

        if (!response.ok) {
          // noinspection ExceptionCaughtLocallyJS
          throw response.statusText + response.status
        }

        const data = await response.json()
        if (data == undefined || !data['request'] || !data['request']['application_identifier']) {
          throw data;
        }
        requestData.application_identifier = data['request']['application_identifier'];

        apiDebugData.value['request'] = requestData
        apiDebugData.value['response'] = data

        if (isDebug) {
          console.log({data})
        }

        if (data['calculator_output']) {
          presentResults(data)

          const obj = `Requested ${formatCurrency(data['request']['loan_amount'], true)}; Allowed ${formatCurrency(data['calculator_output']['maximum_balance'], true)}; Income ${formatCurrency(data['calculator_output']['application_assessable_income'], true)};  `

          reportToInsight('BTL Mortgage Calculation', obj, {
            DTC_MaxMortgageAmount: data['calculator_output']['maximum_balance'],
            DTC_AccessibleIncome: data['calculator_output']['application_assessable_income'],
            DTC_Deposit: data['request']['deposit'],
            DTC_LoanAmount: data['request']['loan_amount'],
            DTC_PropertyValue: data['request']['property_valuation'],
            DTC_LTV: data['request']['product_max_ltv'],
            DTC_LoanType: 'BTL',
            DTC_BuyerType: data['request']['loan_purpose'],
            DTC_PropertyUse: 'N/A',
            DTC_FirstTimeBuyer: 'N/A',
            DTC_Occupation: 'N/A',
            DTC_OccupationType: 'N/A',
            DTC_Stage: data['request']['stage'],
            DTC_CreditExpenditure: data['request']['credit_expenditure']
          })

        } else {
          throw data['errors'] || 'Error'
        }

      } catch (e) {
        console.error('API Error', e);
        submitErrorMessage.value = formSubmitErrorMessage
      } finally {
        loading.value = false
      }
    })


    const findDynamicFields = async function (fields) {
      for (const [key, value] of Object.entries(fields)) {
        const field = fields[key]
        if (field.hasOwnProperty('fields')) {
          await findDynamicFields(field['fields'])
        }

        if (value['dynamicData']) {
          const type = value['dynamicTypeId']
          try {
            const r = await fetch(`/api/formsdata/${type}?$orderBy=Title`);
            const response = await r.json();

            field.options = response.value.map(v => {
                  return {...v, value: v['Value'], label: v['Title']}
                }
            )
          } catch (e) {
            console.error("Fail to load dynamic data:", e)
          }
        }
      }
    }


    const reset = function () {
      resetForm({values: {}})
    }

    onBeforeMount(async () => {
      await findDynamicFields(fields)

      const requiredForBTLPortfolio = (yup) => yup.when('btlExistingPortfolio', (val) => {
            return val ? yup.required() : yup.notRequired().nullable()
          }
      )


      const requiredForJointApplication = (yup, message) => yup.when('applicantsCount', (val) => {
            return parseInt(val) === 2 ? yup.required(message) : yup.notRequired()
          }
      )

      const requiredForIndividualApplicantType = (yup, message) => yup.when('applicantType', (val) => {
            return val === 'Individual' ? yup.required(message) : yup.notRequired()
          }
      )

      const requiredForIndividualApplicantTypeAndJointApplication = (yup, message) => yup.when(['applicantType', 'applicantsCount'], {
        is: (applicantType, applicantsCount) => (applicantType === 'Individual') && parseInt(applicantsCount) === 2,
        then: yup.required(message),
        otherwise: yup.notRequired()
      })

      setSchema({
        applicantType: Yup.string().required(),
        loanPurpose: Yup.string().required(),
        stage: Yup.string().required(),
        loanTermYears: currency().required(),
        monthlyRentalIncome: currency().required().max(8333, 'All BTL cases are subject to an AST, and therefore the maximum allowed rental income is £100,000 per annum.'), // 100,000 / 12 month = 8333
        propertyValuation: currency().required(),
        loanAmount: currency().required().when(['propertyValuation'], (propertyValuation, schema) => {
          let maxValue = Math.ceil(propertyValuation * maxLtv)
          let minValue = Math.ceil(propertyValuation * 0.01)
          return schema.max(maxValue, maxLtvMessage || 'The loan amount is too large for the property value you have entered')
              .min(minValue, 'The loan amount is too low for this property value')
        }),
        btlExistingPortfolio: Yup.boolean().required().typeError('This is a mandatory field'),
        btlPortfolioPropertiesCount: requiredForBTLPortfolio(currency()),
        btlPortfolioMortgagedPropertiesCount: requiredForBTLPortfolio(currency().when(['btlPortfolioPropertiesCount'], (btlPortfolioPropertiesCount, schema) => {
          return schema.max(btlPortfolioPropertiesCount, 'Total number of mortgaged properties cannot be more than total number of properties')
        })),
        btlPortfolioMonthlyCombinedRentalIncome: requiredForBTLPortfolio(currency()),
        btlPortfolioTotalEstimatedPropertiesValue: requiredForBTLPortfolio(currency()),
        btlPortfolioTotalOutstandingMortgagesAmount: requiredForBTLPortfolio(currency().when(['btlPortfolioMortgagedPropertiesCount'], (btlPortfolioMortgagedPropertiesCount, schema) => {
          if (btlPortfolioMortgagedPropertiesCount) {
            return schema.positive('Outstanding mortgage balance must be greater than 0 if there are mortgaged properties')
          } else {
            return schema.max(0, 'Outstanding mortgage balance must be greater than 0 only if there are mortgaged properties')
          }
        })),

        propertyRegion: Yup.string().required(),
        propertyIsHouseInMultipleOccupation: Yup.string().required(),
        propertyIsMultiUnitBlock: Yup.string().required(),

        applicantsCount: requiredForIndividualApplicantType(currency().required()),
        applicant1Income: requiredForIndividualApplicantType(currency().required()),
        applicant2Income: requiredForIndividualApplicantType(requiredForJointApplication(currency())),
        applicant1CreditExpenditure: requiredForIndividualApplicantType(currency()),
        applicant2CreditExpenditure: requiredForIndividualApplicantTypeAndJointApplication(currency()),
        ageGroup: requiredForIndividualApplicantType(currency().min(21, labels['loanMinAgeValidationMessage'] || 'Minimum age to apply for our mortgage is ${min} years old')),
        ageGroup2: requiredForIndividualApplicantType(requiredForJointApplication(currency().min(21, labels['loanMinAgeValidationMessage'] || 'Minimum age to apply for our mortgage is ${min} years old'))),
        postcode: requiredForIndividualApplicantType(postcode())
      })
    })

    onMounted(async () => {
      setTimeout(reset, 0)
    })


    const makeApplicant = function (income, mainApplicant, ageGroup, postcode, jobTitle) {
      let tpl = {
        "main_applicant": mainApplicant,
        "date_of_birth": "0001-01-01",
        "post_code": postcode || "",
        "planned_retirement_age": 70,
        "employment_status": "Employed",
        "salary": parseInt(income),
        "bonus": 0.0,
        "commission": 0.0,
        "overtime": 0.0,
        "allowances": 0.0,
        "self_employed_income": 0.0,
        "ai_score": 0,
        "rn_score": 500,
        "other_income": [],
        "ftb": false
      }

      if (ageGroup) {
        const year = (new Date().getFullYear()) - parseInt(ageGroup)
        tpl.date_of_birth = year + '-01-01'
      }

      return tpl
    }

    const prepareData = function (values) {
      let data = {}

      data['applicant'] = []
      data['applicant'].push(makeApplicant(values.applicant1Income, true, values.ageGroup, values.postcode))

      if (values.applicantsCount > 1) {
        data['applicant'].push(makeApplicant(values.applicant2Income, false, values.ageGroup2, values.postcode))
      }

      data["loan_type"] = "BTL"
      data["loan_subtype"] = values.applicantType // Individual || LimitedCompany
      data["loan_purpose"] = values.loanPurpose // Purchase || Remortgage

      data["loan_amount"] = parseInt(values.loanAmount);

      data["loan_term_requested"] = values.loanTermYears * 12
      data["repayment_type"] = "IO"
      data["number_applicants"] = data['applicant'].length;

      data["property_region"] = values.propertyRegion
      data["property_valuation"] = parseInt(values.propertyValuation);

      const hmo = parseInt(values.propertyIsHouseInMultipleOccupation)
      const mub = parseInt(values.propertyIsMultiUnitBlock)
      const HMOMUB = hmo || mub
      const product = productTable[values.applicantType][HMOMUB ? 'yes' : 'no']

      data["product_code"] = product['product_code'] || ""
      data["product_range"] = product['product_range']
      data["product_description"] = product['product_description']
      data["product_assessment_rate"] = parseFloat(product['product_assessment_rate']);
      data["product_initial_rate_period"] = 60 // hardcoded to 5 years

      data["product_max_ltv"] = parseFloat((data["loan_amount"] / values.propertyValuation).toFixed(2))

      data["product_base_interest_rate"] = 0.0
      data["credit_expenditure"] = parseInt(values['applicant1CreditExpenditure'] || 0) + parseInt(values['applicant2CreditExpenditure'] || 0);
      data["childcare"] = 0.0
      data["school_fees"] = 0.0
      data["maintenance"] = 0.0
      data["ground_rent_service_charge"] = 0.0

      data["number_other_occupants"] = parseInt(values.dependentsUnder16) + parseInt(values.dependentsOver17) || 0;

      if (values.btlExistingPortfolio) {
        data['number_btl_properties'] = parseInt(values['btlPortfolioPropertiesCount'] || 0);
        data['number_btl_mortgaged_properties'] = parseInt(values['btlPortfolioMortgagedPropertiesCount'] || 0);
        data['total_btl_monthly_rental_income'] = parseInt(values['btlPortfolioMonthlyCombinedRentalIncome'] || 0);
        data['total_btl_property_value'] = parseInt(values['btlPortfolioTotalEstimatedPropertiesValue'] || 0);
        data['outstanding_btl_mortgage_balance'] = parseInt(values['btlPortfolioTotalOutstandingMortgagesAmount'] || 0);
      }

      data["property_rental_income"] = parseInt(values['monthlyRentalIncome']);
      data["hmo_mub"] = Boolean(HMOMUB);
      data["equity_loan_htb"] = false
      data["equity_loan_start_date"] = "0001-01-01"

      data['propertyUse'] = values['propertyUse']
      data['stage'] = values['stage']
      data['ageGroup'] = values.ageGroup
      data['propertyIsHouseInMultipleOccupation'] = Boolean(hmo);
      data['propertyIsMultiUnitBlock'] = Boolean(mub);

      data['deposit'] = data['property_valuation'] - data['loan_amount']

      // added so that API debug output matches Axway request
      data['btl_top_up'] = false;
      data['credit_impaired'] = false;
      data['dependentsOver17'] = 0;
      data['dependentsUnder16'] = 0;
      data['pp_io_amount'] = 0;

      return data
    }

    const recalculate = function () {
      calculationResult.value = null
      apiDebugData.value = {}
    }

    const onBtlExistingPortfolioChange = () => {
      let newErrors = {...errors.value}

      const keys = [
        'btlPortfolioPropertiesCount',
        'btlPortfolioMortgagedPropertiesCount',
        'btlPortfolioMonthlyCombinedRentalIncome',
        'btlPortfolioTotalEstimatedPropertiesValue',
        'btlPortfolioTotalOutstandingMortgagesAmount'
      ]

      keys.forEach(k => delete newErrors[k])

      resetForm({
        values: {
          ...values.value,
        },
        errors: newErrors
      })
    }


    const onApplicantTypeChange = () => {
      let newErrors = {...errors.value}

      const keys = [
        'applicantsCount',
        'applicant2Income',
        'applicant1CreditExpenditure',
        'applicant2CreditExpenditure',
        'ageGroup',
        'ageGroup2',
        'postcode',
      ]

      keys.forEach(k => delete newErrors[k])

      resetForm({
        values: {
          ...values.value,
        },
        errors: newErrors
      })

    };

    const requestLikeCallback = function () {
      let data = JSON.parse(JSON.stringify(calculationResult.value))
      data.requestingLikeCallback = true
      history.pushState({data}, 'Request Like Callback')
      requestingLikeCallback.value = true
    }

    return {
      isDebug,
      onSubmit,
      handleSubmit,
      submitCount,
      setErrors,
      errors,
      handleReset,
      isSubmitting,
      meta,
      values,
      isValid,
      schema,
      errs,
      props,
      fields,
      labels,
      loading,
      submitErrorMessage,
      loadingMaskMessage,
      introSectionTitle,
      introSectionBody,
      formSectionTitle,
      formSectionBody,
      beforeIntroSection,
      calculationResult,
      recalculate,
      onBtlExistingPortfolioChange,
      onApplicantTypeChange,
      apiDebugData,

      requestLikeCallback,
      requestingLikeCallback
    }


  }
}
</script>

